import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Animations
import { RightToLeftAnimationDirective } from './animations/right-to-left-animation.directive';
import { LongPressDirective } from './long-press/long-press.directive';
import { IntersectionObserverDirective } from './intersection-observer/intersection-observer.directive';

const DIRECTIVES = [RightToLeftAnimationDirective, LongPressDirective, IntersectionObserverDirective];

@NgModule({
  declarations: [...DIRECTIVES],
  imports: [CommonModule],
  exports: [...DIRECTIVES],
})
export class DirectivesModule {}
